import request from '../../src/server/request.js';
// ../../src/request.js
// const url = 'https://back.lzbbyc.com/youcheping/wechat/api'
const url = 'http://192.168.3.35:8089/foo_admin_war_exploded/wechat/api'

// 查询用户列表
const getUserList = (params)=> {
 return request({
        url: url + `/user/list`,
        params,
        method: 'get'
    })
}
export {
	getUserList
} 